<template>
  <div class="logo-carousel">
    <VueSlickCarousel v-bind="settings" ref="carousel">
      <!-- Logos dinámicos -->
      <div v-for="(logo, index) in logos" :key="index" class="logo-item">
        <img :src="logo" alt="Logo" />
      </div>
    </VueSlickCarousel>

    <!-- Botones de navegación -->
    <div class="carousel-arrows">
      <button @click="prev">⬅</button>
      <button @click="next">➡</button>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  components: { VueSlickCarousel },
  data () {
    return {
      logos: [
        '/assets/images/logo1.png',
        '/assets/images/logo2.png',
        '/assets/images/logo3.png',
        '/assets/images/logo4.png',
        '/assets/images/logo5.png',
        '/assets/images/logo6.png',
        '/assets/images/logobelden.svg',
      ],
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
          { breakpoint: 992, settings: { slidesToShow: 3 } },
          { breakpoint: 768, settings: { slidesToShow: 2 } },
          { breakpoint: 480, settings: { slidesToShow: 1 } }
        ]
      }
    }
  },
  methods: {
    next () {
      this.$refs.carousel.next()
    },
    prev () {
      this.$refs.carousel.prev()
    }
  }
}
</script>

<style scoped>
.logo-carousel {
  position: relative;
  max-width: 1200px;
  margin: auto;
}

.logo-item {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px; /* separación interna */
}

.logo-item img {
  height: 80px;        /* altura fija para todos */
  width: auto;         /* mantiene proporción */
  object-fit: contain; /* evita deformación */
  margin: 0 10px;      /* separación lateral */
}
.carousel-arrows {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}
.carousel-arrows button {
  background: #333;
  color: white;
  border: none;
  padding: 8px 12px;
  margin: 0 5px;
  cursor: pointer;
  border-radius: 4px;
}
.carousel-arrows button:hover {
  background: #555;
}
</style>
